<clr-alerts>
  <clr-alert [clrAlertType]="'danger'" [clrAlertClosable]="false">
    <clr-alert-item>
      <span>You do not have permission to view this page</span>
    </clr-alert-item>
  </clr-alert>
</clr-alerts>
